





























































import Vue from "vue";
import RequiredLabel from "./../interface/RequiredLabel.vue";
export default Vue.extend({
  name: "text-input",
  components: { RequiredLabel },
  props: {
    id: {
      type: String,
      required: true,
    },
    info: {
      type: String,
      required: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
    },
    isNew: {
      type: Boolean,
      required: false,
    },
    isDirty: {
      type: Boolean,
      required: false,
      default: false,
    },
    validationObject: {
      type: Object,
      required: true,
    },
    inputRemark: {
      type: String,
      required: false,
      default: null,
    },
    maxLength: {
      type: Number,
      required: false,
      default: null,
    }
  },
  data() {
    return {};
  },
  methods: {
    updateValue(value): void {
      this.$emit("input", value);
    },
  },
  computed: {
    isRequired(): boolean {
      return Object.prototype.hasOwnProperty.call(
        this.validationObject,
        "required"
      );
    },
  },
});
